"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledReloadIcon = exports.StyledTreeNodeMenuButton = exports.StyledProcessingSpinner = exports.StyledTitle = exports.StyledTreeItem = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const x_tree_view_1 = require("@mui/x-tree-view");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../../../icons");
const common_1 = require("../../../../product-editor/components/common");
exports.StyledTreeItem = (0, styled_components_1.default)(x_tree_view_1.TreeItem) `
  .MuiTreeItem-group,
  .MuiTreeItem-groupTransition {
    margin-left: ${({ theme }) => theme.spacing(2)};
    border-left: ${({ theme }) => theme.typography.pxToRem(1)} solid ${ui_components_1.baseColors.primaryBlueMed100};
  }

  .tree-item-change-mark {
    position: absolute;
    left: 0;
  }

  .MuiTreeItem-iconContainer {
    pointer-events: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${({ theme }) => theme.spacing(3.5)};
    min-width: ${({ theme }) => theme.spacing(3.5)};

    svg {
      font-size: ${({ theme }) => theme.spacing(3.5)};
    }
  }

  .MuiTreeItem-root.node--disabled {
    cursor: default;
    pointer-events: none;
    color: ${({ theme }) => theme.palette.action.disabled};
  }

  &.node--highlighted {
    .MuiTreeItem-content.MuiTreeItem-content {
      background-color: ${ui_components_1.baseColors.primaryGreen001};
    }

    .MuiTreeItem-label.MuiTreeItem-label {
      color: ${ui_components_1.baseColors.primaryGreen300};

      .MuiTypography-root.MuiTypography-root {
        color: ${ui_components_1.baseColors.primaryGreen300};
      }

      .node-total-count.node-total-count {
        color: ${ui_components_1.baseColors.primaryGreen400};
      }

      .tree-node-menu-button {
        svg {
          path {
            fill: white !important;
          }
        }
      }
    }
  }

  .MuiTreeItem-label {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    gap: ${({ theme }) => theme.spacing(1)};

    .MuiTypography-body1 {
      font-size:  ${({ theme }) => theme.spacing(1.5)};
    }
  }

  .MuiTreeItem-content {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding-top: ${({ theme }) => theme.spacing(0.5)};
    padding-bottom: ${({ theme }) => theme.spacing(0.5)};
    padding-right: 0;

    &.Mui-selected {
      background-color: ${ui_components_1.baseColors.primaryGreen001};

      &:hover {
        background-color: ${ui_components_1.baseColors.primaryGreen001};
      }
    }

    &:hover:not(.Mui-selected) {
      background-color: ${ui_components_1.baseColors.background000};
    }

    &:hover {
      .tree-node-menu-button {
        visibility: visible;
      }
    }
  }
`;
exports.StyledTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  overflow: hidden;

  .node-title {
    margin-right: auto;
  }

  .node-total-count {
    margin-left: 0.5rem;
    line-height: 1;

    &:last-child {
      margin-right: 0.5rem;
    }
  }

  .tree-node-menu-button {
    visibility: hidden;
  }
`;
exports.StyledProcessingSpinner = (0, styled_components_1.default)(common_1.ProcessingSpinner) `
  display: flex;

  && svg {
    font-size: ${({ $secondary }) => ($secondary ? '1rem' : '1.5rem')};

    path {
      fill: ${({ $secondary, theme }) => ($secondary ? theme.palette.text.secondary : theme.palette.primary.main)};
    }
  }
`;
exports.StyledTreeNodeMenuButton = (0, styled_components_1.default)(material_1.IconButton) `
  svg {
    path {
      transform: translate(55%, 15%);
      scale: 0.7;
      fill: ${ui_components_1.baseColors.gray300};
    }
  }
`;
exports.StyledReloadIcon = (0, styled_components_1.default)(icons_1.ReloadIcon) `
  color: ${ui_components_1.baseColors.primaryGreen400};
  font-size: 1rem;
  margin: 0 ${({ theme }) => theme.spacing(0.5)};
  animation: rotate 1s linear infinite;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }

  path {
    fill: none;
  }
`;
